import React from "react";
import "flowbite";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AuthContextProvider } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";

//Erro
import Error404 from "./pages/Private/error/404";
import DisplayPage from "./pages/Private/error/DisplayPage";

//Protect Router
import RedirectRouteLogin from "./routes/RedirectRouteLogin";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./pages/Public/login/Login";

//Dashboard
import Dashboard from "./pages/Private/dashboard/Index";

//Financeiro
import RedirectFinanceiroVendas from "./routes/sectors/financeiro/RedirectFinanceiroVendas";
import RedirectFinanceiroSaque from "./routes/sectors/financeiro/RedirectFinanceiroSaque";
import FinanceiroVendas from "./pages/Private/financeiro/vendas";
import FinanceiroSaque from "./pages/Private/financeiro/saque";

//Sorteios
import RedirectSorteiosCriar from "./routes/sectors/sorteios/RedirectSorteiosCriar";
import RedirectSorteiosHistorico from "./routes/sectors/sorteios/RedirectSorteiosHistorico";

//Configuração
import RedirectConfiguracaoSistema from "./routes/sectors/configuracao/RedirectConfiguracaoSistema";
import RedirectConfiguracaoUsers from "./routes/sectors/configuracao/RedirectConfiguracaoUsers";
import ConfiguracaoSistema from "./pages/Private/configuracao/sistema";
import ConfiguracaoUsers from "./pages/Private/configuracao/users";

//Clientes
import RedirectClientesCadastrar from "./routes/sectors/clientes/RedirectClientesCadastrar";
import RedirectClientesList from "./routes/sectors/clientes/RedirectClientesListar";
import ClientCreate from "./pages/Private/clientes/cadastrar";
import ClientList from "./pages/Private/clientes/listar";
import ClientEdit from "./pages/Private/clientes/edit";

//Marketing
import RedirectMarketingBanners from "./routes/sectors/marketing/RedirectMarketingBanners";
import MarketingBanners from "./pages/Private/marketing/banners";

//Suporte
import RedirectSuporteChat from "./routes/sectors/suporte/RedirectSuporteChat";
import SuporteChat from "./pages/Private/suporte/chat";

/**
 * 2º @Versão
 */

//Sorteios
import SorteiosHistorico_v2 from "./pages/Private/sorteios_v2/listar/Index";
import SorteiosCriar_v2 from "./pages/Private/sorteios_v2/criar/Index";
import SorteiosHistoricoEdit_v2 from "./pages/Private/sorteios_v2/editar/Index";

import PreCadastro from "./pages/Private/pre_cadastro/Index";
import AnalisandoDocumento from "./pages/Private/analisando_documento/Index";

function App() {
  return (
    <>
      <div className="application">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Vizzo Paymennts</title>
        </Helmet>
      </div>
      <BrowserRouter>
        <SidebarProvider>
          <AuthContextProvider>
            <Routes>
              <Route path="*" element={<Error404 />} />
              <Route path="/err404" element={<Error404 />} />
              <Route path="/errD" element={<DisplayPage />} />

              <Route element={<RedirectRouteLogin />}>
                <Route index element={<Login />} />
              </Route>

              <Route element={<ProtectedRoute />}>
                <Route path="*" element={<Error404 />} />
              </Route>
            </Routes>
          </AuthContextProvider>
        </SidebarProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
